import { Modal, Button, Form, Popover, FormGroup, OverlayTrigger } from 'react-bootstrap';
import { CheckLg, Clock, ClockHistory, DashCircle, EyeSlash, FileEarmark, FileEarmarkText, PencilFill, X } from 'react-bootstrap-icons';
import { useDispatch } from "react-redux";
import { Fragment, useRef, useState } from "react";
import { deleteReminder, editReminder, postponeReminder, readReminder } from "../../store/api/ReminderAPI";
import DatePicker from "react-datepicker2";
import momentJalaali from "moment-jalali";
import "react-datepicker2/src/styles/style.css";
import { addNewReminder } from "../../store/api/ReminderAPI";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay, faClock, faTimes } from '@fortawesome/free-solid-svg-icons';
import { setDialog } from '../../store/api/CommonFunctions';
const ModalReminder = ({ attachmentType, attachmentID, pop, setPop }) => {
    const submitData = useRef({ IsPrivate: true });
    const [err, setError] = useState({});
    const { show, reminder, onAddEdit, setUnreadReminders } = pop;
    const atcType = reminder?.AttachmentType ?? attachmentType;
    const atcID = reminder?.AttachmentID ?? attachmentID;
    const atcTypeArray = {
        "customer": "طرف حساب",
        "pre_customer": "مشتری بالقوه",
        "acc_doc": "سند حسابداری",
        "install": "سرویس نصب",
        "repair": "سرویس تعمیر",
        "Sale": "فاکتور فروش",
        "PreSale": "پیش فاکتور فروش",
        "Purchase": "فاکتور خرید",
        "PrePurchase": "پیش فاکتور خرید",
        "ReturnFromSale": "برگشت از فروش",
        "ReturnFromPurchase": "برگشت از خرید",
        "Borrow": "حواله به نماینده",
        "ReturnFromBorrow": "برگشت حواله نماینده",
        "OldParts": "در قبال داغی",
        "OutOfOrder": "فاکتور ضایعات",
        "Resid": "رسید انبار",
        "Havaleh": "حواله انبار",
        "Transfer": "انتقال بین انبارها",
        "staff": "نماینده/تکنسین/پرسنل",
        "": "عمومی",
        undefined: "عمومی"
    }
    const pAttachType = atcTypeArray[atcType?.replace("Formal", "").replace("Invoice", "")];
    const dispatch = useDispatch();

    const close = () => {
        setPop({ show: false });
    }
    function showReminderAttachment() {
        switch (atcType.toLowerCase()) {
            case "customer":
                window.open(`/CRM/AddEditCustomer/${atcID}`);
                break;
            case "pre_customer":
                window.open(`/CRM/AddEditPreCustomer/${atcID}`);
                break;
            case "acc_doc":
                window.open(`/Accounting/AddEditDocument/${atcID}`);
                break;
            case "install":
                window.open(`/Services/Service/${atcID}/install`);
                break;
            case "repair":
                window.open(`/Services/Service/${atcID}/repair`);
                break;
            default:
                if (atcType.toLowerCase().includes("invoice")) {
                    const invoiceType = atcType.replace("Invoice", "").replace("Formal", "");
                    window.open(`/Sale/Invoice/${invoiceType}/${atcID}/${atcType.includes("Formal")}`)
                }

        }
    }
    const onSuccess = () => {
        submitData.current = { IsPrivate: true }
        close();
        if (onAddEdit) {
            onAddEdit();
        }
    }
    function postpone(){
        const onPost =(res)=>{
            if(res.Data)
            {
                //dispatch(searchUnreadReminders(0));
                setUnreadReminders?.();
                close();
            }
        }
        postponeReminder(reminder.ID, reminder.PostponeDate, onPost);
    }

    function read() {
        const onRead = (res) => {
            close();
           //dispatch(searchUnreadReminders(0));
           setUnreadReminders?.();
        }
        dispatch(readReminder(reminder.ID, onRead));
    }
    function delReminder() {
        const onDelete = (res) => {
            close();
            //dispatch(searchUnreadReminders(0));
            setUnreadReminders?.();
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف یادآوری',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: deleteReminder(reminder.ID, onDelete)
        }))
    }
    function submit() {
        if (!reminder || !reminder.ID) {
            let e = {};
            if (!submitData.current.RemBody || submitData.current.RemBody === '') {
                e.RemBody = "N";
            }
            if (!submitData.current.AlarmDate) {
                e.AlarmDate = "N";
            }
            setError(e);
            if (e.RemBody || e.AlarmDate) {
                return;
            }

            submitData.current.AttachmentID = attachmentID;
            submitData.current.AttachmentType = attachmentType;
            dispatch(addNewReminder(submitData.current, onSuccess));
        }
        else {
            if (submitData.current.RemBody && submitData.current.RemBody !== '') {
                reminder.RemBody = submitData.current.RemBody;
            }
            if (submitData.current.AlarmDate) {
                reminder.AlarmDate = submitData.current.AlarmDate;
            }
            dispatch(editReminder(reminder, onSuccess));
        }
    }
    const popPostPone = (
        <Popover style={{fontFamily:"Vazir"}}>
            <Popover.Title className='headerStyle'>
                <Clock size={18}/>&nbsp;
                تعویق یادآوری</Popover.Title>
            <Popover.Content className='bodyStyle'>
                <FormGroup>
                    <DatePicker className='form-control' timePicker={false} isGregorian={false} onChange={val => reminder.PostponeDate = val.local("en").format("YYYY-MM-DD")} />
                </FormGroup>
                <Button className='group-Btn mt-2' variant='info' onClick={postpone}><ClockHistory size={18}/>&nbsp; تعویق یادآوری</Button>                
            </Popover.Content>
        </Popover>
    )
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span><FontAwesomeIcon icon={faCalendarDay} size="lg" /> &nbsp; یادآوری {pAttachType}</span>
                <span onClick={close} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={faTimes} size="lg" /></span>
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                <div className="form-group">
                    <label>متن یادآوری</label>
                    <Form.Control as="textarea" style={{ fontSize: "13px" }} rows={2}
                        defaultValue={reminder && reminder.RemBody ? reminder.RemBody : ""}
                        onChange={e => submitData.current.RemBody = e.target.value} />
                    {err.RemBody && <small className="errors">متن یادآوری الزامی است</small>}
                </div>
                <div className="form-group">
                    <label>تاریخ و ساعت یادآوری</label>
                    <DatePicker name="AlarmDate" isGregorian={false} timePicker={true} className="form-control"
                        value={reminder && reminder.AlarmDate ? momentJalaali(reminder.AlarmDate) : momentJalaali().add(5,"minute")}
                        onChange={value => { submitData.current.AlarmDate = value.local("en").format("YYYY/MM/DD HH:mm") }} />
                    {err.AlarmDate && <small className="errors">تاریخ نمایش الزامی است</small>}
                </div>
                <div className='form-group'>
                    <input type='checkbox' className='form-check-input' style={{ borderColor: "#6565e9", borderWidth: "2px" }}
                        defaultChecked={reminder && reminder.IsPrivate !== undefined ? reminder.IsPrivate : true}
                        onChange={e => submitData.current.IsPrivate = e.target.checked}
                    />
                    &nbsp;
                    <label style={{ color: "blue", marginTop: "2px" }}>فقط برای خودم</label>
                </div>
                <div className="mt-2">
                    <Button variant="success" className="group-Btn-smalll" onClick={submit}>
                        {Number(reminder?.ID) > 0 &&
                            <Fragment><PencilFill />&nbsp;ویرایش یادآوری</Fragment>
                        }
                        {!(Number(reminder?.ID) > 0) &&
                            <Fragment>
                                <CheckLg />&nbsp;ثبت یادآوری
                            </Fragment>}
                    </Button>
                    {Number(reminder?.ID) > 0 && atcType &&
                        <Button className="group-Btn-smalll" onClick={showReminderAttachment}>
                            <FileEarmarkText size={18} />&nbsp;
                            نمایش {pAttachType}
                        </Button>}
                    {Number(reminder?.ID) > 0 &&
                        <Fragment>
                            <Button className='group-Btn-smalll' variant='info' onClick={read}>
                                <EyeSlash size={16} />&nbsp;نمایش نده
                            </Button>
                            <Button className='group-Btn-smalll' variant='danger' onClick={delReminder}><DashCircle size={16} />&nbsp; حذف یادآوری</Button>
                            <OverlayTrigger overlay={popPostPone} trigger="click" placement='top' rootClose>
                                <Button title='تعویق' className='group-Btn-smalll'><FontAwesomeIcon icon={faClock} size='lg' /></Button>
                            </OverlayTrigger>
                        </Fragment>
                    }
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalReminder;